import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsButtonModule, DsFormFieldModule, DsFormsModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { GcdmLanguageContainer } from '../../../consent/components/consent-data/gcdm-language.container';
import { IdCreationStatus } from '../../../customer/services/customer.service';
import { MessageComponent } from '../../../form/components/message/message.component';
import { useI18n } from '../../../i18n/services/i18n.service';
import { ButtonRowComponent } from '../../../modal/button/button-row.component';

@Component({
  selector: 'cdf-create-bmw-mini-id',
  imports: [
    DsButtonModule,
    MessageComponent,
    DsFormFieldModule,
    DsFormsModule,
    FormsModule,
    DsTooltipDirectiveModule,
    GcdmLanguageContainer,
    ButtonRowComponent,
  ],
  template: `
    <h2 class="header">{{ i18n('createBmwOrMiniIdModal.title') }}</h2>

    <p class="question">{{ i18n('createBmwOrMiniIdModal.whichKindOfId') }}</p>
    <p class="text-label further-information">
      {{ i18n('createBmwOrMiniIdModal.additionalInformation') }}
    </p>
    <hr />
    <div class="bmw-mini-id">
      <span class="col-auto text-label text-neutral">{{ i18n('createBmwOrMiniIdModal.emailForCreation') }}:</span>
      <span class="col-auto text-label">{{ email() }}</span>
    </div>
    <cdf-gcdm-language-container
      class="align-self-end"
      [label]="i18n('customerComparisonField.CORRESPONDENCE_LANGUAGE')"
      [correspondenceLanguage]="correspondenceLanguage()"
    />
    <cdf-button-row>
      <ds-button variant="ghost" (click)="closeModal.emit()">
        {{ i18n('createBmwOrMiniIdModal.button.cancel') }}
      </ds-button>
      <ds-button ds-loading variant="outline" (click)="createMiniId.emit()" [isLoading]="isLoading()">
        {{ i18n('createBmwOrMiniIdModal.button.createMiniId') }}
      </ds-button>
      <ds-button ds-loading variant="outline" (click)="createBmwId.emit()" [isLoading]="isLoading()">
        {{ i18n('createBmwOrMiniIdModal.button.createBmwId') }}
      </ds-button>
    </cdf-button-row>

    @if (hasFailed()) {
      <cdf-message class="message" tone="critical" [text]="i18n('createBmwOrMiniIdModal.couldNotCreateIdError')" />
    }
  `,
  styleUrl: './create-bmw-mini-id.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateBmwMiniIdComponent {
  readonly i18n = useI18n();

  readonly idCreationStatus = model<IdCreationStatus>();

  readonly email = input.required<string>();
  readonly correspondenceLanguage = input.required<string | undefined>();

  readonly closeModal = output();
  readonly createBmwId = output();
  readonly createMiniId = output();

  protected readonly isLoading = computed(() => this.idCreationStatus() === IdCreationStatus.LOADING);
  protected readonly hasFailed = computed(() => this.idCreationStatus() === IdCreationStatus.FAILED);
}
